import React from 'react';

// IB-677 rework — per-type "movement this period": two cells (New / Closed) read
// from the Phase-1 snapshot delta. When no baseline exists the widget shows a
// compact dashed empty-state card that explains itself, rather than misleading
// zeros or a full-width strip. Renders bare content — the skeleton wraps it in a
// titled card. movement: { has_baseline, baseline_captured_at?, <category>:{new,closed} }

export function MovementEmpty() {
    return (
        <div className="tw-rounded-lg tw-border tw-border-dashed tw-border-charcoal-25 tw-p-4 tw-text-center">
            <div className="tw-mb-1 tw-text-sm tw-font-semibold tw-text-charcoal">{$t('No baseline yet')}</div>
            <div className="tw-mx-auto tw-text-xs tw-leading-snug tw-text-charcoal-75" style={{ maxWidth: 280 }}>
                {$t('Movement compares against the last weekly snapshot. It appears once a second weekly snapshot has been captured.')}
            </div>
        </div>
    );
}

export function MovementFoot({ movement }) {
    return (
        <div className="tw-mt-2 tw-text-2xs tw-text-charcoal-50">
            {$t('vs last weekly snapshot')}
            {movement?.baseline_captured_at ? ` · ${movement.baseline_captured_at}` : ''}
        </div>
    );
}

function Cell({ value, label, tone }) {
    return (
        <div className="tw-rounded-lg tw-border tw-border-grey tw-p-2.5 tw-text-center">
            <div className={`tw-text-xl tw-font-bold ${tone}`}>{value}</div>
            <div className="tw-text-2xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-charcoal-50">{label}</div>
        </div>
    );
}

export default function MovementWidget({ movement, category }) {
    if (!movement || !movement.has_baseline) {
        return <MovementEmpty />;
    }

    const entry = category ? movement[category] : null;

    return (
        <div>
            <div className="tw-grid tw-grid-cols-2 tw-gap-2">
                <Cell value={entry?.new ?? 0} label={$t('New')} tone="tw-text-blue" />
                <Cell value={entry?.closed ?? 0} label={$t('Closed')} tone="tw-text-charcoal-50" />
            </div>
            <MovementFoot movement={movement} />
        </div>
    );
}
